import { Cidade } from "../../endereco.model";
import { Rota } from "./rota.model";

export class TrechoRodoviario {
    Id: number = 0;
    Nome: string = "";
    RotaRodoviariaId: number;
    RotaRodoviaria: Rota;
    CidadeSaidaId: number;
    CidadeSaida: Cidade = new Cidade();
    Ordem: number = 0;
    TarifaAdulto: number = 0;
    TarifaCHD: number = 0;
    TarifaCHD2: number = 0;
}